import moment from "moment/moment";
import "moment/locale/fr";
import "moment/locale/ar";
moment.locale("fr");
import {
  Conflict,
  Order,
  OrderStatus,
  Product,
  SourcingRequest,
  User,
  Versement,
} from "./types";
import { availableName } from "./fncts";

export const createAdminAccountEmail = (user: {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
}) => {
  return `<html lang="fr">
        <body>
            <p>Cher ${user?.first_name} ${user?.last_name},</p>
            <p>Nous avons créé un nouveau compte administrateur pour vous. Voici vos informations de connexion :</p>
            <ul>
                <li><strong>Nom d'utilisateur :</strong> ${user?.first_name} ${user?.last_name}</li>
                <li><strong>Email :</strong> ${user?.email}</li>
                <li><strong>Mot de passe temporaire :</strong> ${user?.password}</li>
            </ul>
            <p>Accédez à la <a href="https://www.amazighgroupe.com/fr/login">page de connexion</a> pour vous connecter.</p>
            <p>Pour toute assistance, contactez-nous.</p>
            <p>Cordialement,</p>
                  Amazigh Group <br />
            Didouche Mourad, Algiers, Algeria <br />
            +213794106619 <br />
        </body>
        </html>`;
};

export const createUserAccountEmail = (user: {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
}) => {
  return `<html lang="fr">
        <body>
            <p>Cher ${user?.first_name} ${user?.last_name},</p>
    
            <p>Nous avons créé un nouveau compte client pour vous. Voici vos informations de connexion :</p>
    
            <ul>
                <li><strong>Nom d'utilisateur :</strong> ${user?.first_name} ${user?.last_name}</li>
                <li><strong>Email :</strong> ${user?.email}</li>
                <li><strong>Mot de passe temporaire :</strong> ${user?.password}</li>
            </ul>
    
            <p>Accédez à la <a href="https://www.amazighgroupe.com/fr/login">page de connexion</a> pour vous connecter.</p>
    
            <p>Pour toute assistance, contactez-nous.</p>
    
            <p>Cordialement,</p>
            Amazigh Group <br />
            Didouche Mourad, Algiers, Algeria <br />
            +213794106619 <br />
  
        </body>
        </html>`;
};
export const OrderStatusChanged = ({
  user,
  order,
}: {
  user: { first_name: string; last_name: string; email: string };
  order: Order;
}) => {
  return `<html lang="fr">
        <body>
        <p>Cher ${user?.first_name} ${user?.last_name},</p>
        <p>Nous espérons que ce message vous trouve bien. Nous vous informons que le statut de votre commande numéro ${
          order?.id
        } a récemment été mis à jour.</p>
        <p>Votre commande est maintenant passée au statut suivant : ${
          (order?.status as OrderStatus).name
        }.</p>
        <ul>
            <li> <strong>Date de la commande :</strong> ${moment(order?.date)
              .locale("fr")
              .calendar()} </li>
            <li><strong>Status actuel :</strong>  ${
              (order?.status as OrderStatus).name
            }</li>
            <li> <strong>Produit commandé : </strong>${
              // order?.product?.name?.fr
              availableName(order?.product?.name, "fr")
            } </li>
            <li> <strong>Quantité :</strong> ${order?.quantity} </li>
            <li> <strong>Prix total :</strong>  ${order?.total_price} DA </li>
        </ul>
        <p>Nous tenons à vous assurer que notre équipe travaille sans relâche pour garantir que votre expérience d'achat soit aussi fluide que possible. Si vous avez des questions ou des préoccupations concernant votre commande, n'hésitez pas à nous contacter </p>
        <p>Nous vous remercions de votre confiance et de votre fidélité. Nous sommes impatients de vous servir à nouveau à l'avenir.</p>
        <p>Cordialement,<br />
             Amazigh Group <br />
            Didouche Mourad, Algiers, Algeria <br />
            +213794106619 <br />
        </body>
        </html>`;
};
export const SourcingStatusChanged = ({
  user,
  order,
}: {
  user: { first_name: string; last_name: string; email: string };
  order: SourcingRequest;
}) => {
  return `<html lang="fr">
        <body>
        <p>Cher ${user?.first_name} ${user?.last_name},</p>
        <p>Nous espérons que ce message vous trouve bien. Nous vous informons que le statut de votre demande de sourcing numéro ${
          order?.id
        } a récemment été mis à jour.</p>
        <p>Votre  demande de sourcing est maintenant passée au statut suivant : ${
          (order?.status as OrderStatus).name
        }.</p>
        <ul>
            <li> <strong>Date de la  demande de sourcing :</strong> ${moment(
              order?.date
            )
              .locale("fr")
              .calendar()} </li>
            <li><strong>Status actuel :</strong>  ${
              (order?.status as OrderStatus).name
            }</li>
           
        </ul>
        <p>Nous tenons à vous assurer que notre équipe travaille sans relâche pour garantir que votre expérience d'achat soit aussi fluide que possible. Si vous avez des questions ou des préoccupations concernant votre commande, n'hésitez pas à nous contacter </p>
        <p>Nous vous remercions de votre confiance et de votre fidélité. Nous sommes impatients de vous servir à nouveau à l'avenir.</p>
        <p>Cordialement,<br />
              Amazigh Group <br />
            Didouche Mourad, Algiers, Algeria <br />
            +213794106619 <br />
        </body>
        </html>`;
};

export const PayementConfirmationEmail = (versement: Versement) => {
  return `<html lang="fr">
  <body>
  <p>Cher ${versement.order?.user?.first_name} ${
    versement.order?.user?.last_name
  },</p>
  <p>Nous espérons que ce message vous trouve bien. Nous vous informons que  votre paiement numéro ${
    versement.id
  } a été confirmé.</p>
  <ul>
  <li><strong>Date du versement : </strong> ${moment(
    versement.date
  ).calendar()} </li>
  <li><strong>Date de confirmation : </strong> ${moment().format(
    "YYYY-MM-DD à HH:mm"
  )} </li>
  <li><strong>Somme versée : </strong> ${versement.amount} DA</li>
  <li><strong>Somme restante : </strong> ${
    versement.order!.total_price! - versement.amount
  }  DA</li>
  </ul>
  <p>Nous tenons à vous assurer que notre équipe travaille sans relâche pour garantir que votre expérience d'achat soit aussi fluide que possible. Si vous avez des questions ou des préoccupations concernant votre commande, n'hésitez pas à nous contacter </p>
  <p>Nous vous remercions de votre confiance et de votre fidélité. Nous sommes impatients de vous servir à nouveau à l'avenir.</p>
  <p>Cordialement,<br />
      Amazigh Group <br />
            Didouche Mourad, Algiers, Algeria <br />
            +213794106619 <br />
  </body>
  </html>
  `;
};

export const PayementRejectionEmail = ({
  versement,
  details,
}: {
  versement: Versement;
  details: string;
}) => {
  return `<html lang="fr">
  <body>
    <p>Cher ${versement.order?.user?.first_name} ${
    versement.order?.user?.last_name
  },</p>
    <p>Nous espérons que ce message vous trouve bien. Nous regrettons de vous informer que votre paiement numéro ${
      versement.id
    } a été rejeté.</p>
    <ul>
      <li><strong>Date du versement : </strong> ${moment(
        versement.date
      ).calendar()} </li>
      <li><strong>Motif du rejet : </strong> ${details} </li>
    </ul>
    <p>Nous comprenons que cela peut être décevant, et nous nous excusons pour tout inconvénient que cela pourrait causer?. Si vous avez des questions ou si vous souhaitez discuter de cette situation, n'hésitez pas à nous contacter.</p>
    <p>Nous vous remercions de votre compréhension et espérons pouvoir résoudre cette situation rapidement.</p>
    <p>Cordialement,<br />
           Amazigh Group <br />
            Didouche Mourad, Algiers, Algeria <br />
            +213794106619 <br />
  </body>
</html>
  `;
};

export const ConflictNewMsgEmail = ({
  user,
  conflict,
  msg,
}: {
  user: any;
  conflict: number;
  msg: string;
}) => {
  return `<html lang="fr">
  <body>
    <p>Cher ${user?.first_name} ${user?.last_name},</p>
    <p>Nous espérons que ce message vous trouve bien. Nous tenons à vous informer qu'un nouveau message a été reçu concernant le conflit n° ${conflict}.</p>
    <p>Voici un bref résumé du message :</p>
    <blockquote>
      ${msg}
    </blockquote>
    <p>Nous prenons cette situation au sérieux et notre équipe examine attentivement les détails. Nous vous tiendrons informé(e) dès que des mises à jour ou des résolutions seront disponibles.</p>
    <p>Si vous avez des informations supplémentaires à partager ou si vous avez des préoccupations, n'hésitez pas à répondre à cet e-mail.</p>
    <p>Merci de votre compréhension et de votre coopération.</p>
    <p>Cordialement,<br />
          Amazigh Group <br />
            Didouche Mourad, Algiers, Algeria <br />
            +213794106619 <br />
  </body>
</html>

  `;
};

export const quotationEmail = ({
  user,
  order,
  product,
}: {
  user: { first_name: string; last_name: string };
  order: Order;
  product: Product;
}) => {
  return `
<html lang="fr">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Devis pour votre commande</title>
</head>
<body>

  <p>Cher(e) ${user?.first_name} ${user?.last_name},</p>

  <p>Nous vous remercions pour votre commande chez Amazigh Groups. Veuillez trouver ci-dessous le devis correspondant.</p>

  <table border="1" cellpadding="10">
    <tr>
      <th>Article</th>
      <td>${availableName(product?.name , "fr")}</td>     
    </tr>
    <tr>
      <th>Quantité</th>
      <td>${order?.quantity}</td>    
    </tr>
    <tr> <th>Prix unitaire</th>
    <td>${order?.unit_price ? order?.unit_price : "..."} DA</td></tr>
    <tr> <th>Total</th>
    <td> ${order?.total_price ? order?.total_price : "..."} DA</td></tr>
    <tr> <th>Adresse de livaison</th>
    <td> ${order?.shipping_adress} </td></tr>
    <tr> <th>Date de la commande</th>
    <td> ${moment(order?.date).format("DD-MM-YYYY HH:mm")} </td></tr>
   ${
     order?.is_special &&
     `   <tr> <th>URL du produit</th>
     <td> ${order?.product?.url} </td></tr>
     <tr> <th>Dimensions du carton</th>
   <td> ${order?.product?.package_info?.width}cm * ${order?.product?.package_info?.length}cm * ${order?.product?.package_info?.height}cm </td> </tr>  
     <tr> <th>Prix unitaire du produit ($)</th>
      <td> ${order?.product?.price} DA</td></tr>
      <tr> <th>Poids du carton (en kg)</th>
      <td>${order?.product?.weight}</td></tr>
    `
   }
   
  </table>

  <p><strong>Total :${
    order?.total_price ? order?.total_price : "..."
  } DA</strong></p>
  ${
    order?.total_price == 0
      ? `<p>Le devis de votre commande n'a pas été encode établi par notre équipe. Nous vous le communiquerons au plus vite.</p>`
      : ""
  }

  <p> N'hésitez pas à nous contacter pour toute question ou ajustement éventuel.</p>

  <p>Cordialement,</p>
      Amazigh Group <br />
            Didouche Mourad, Algiers, Algeria <br />
            +213794106619 <br />

</body>
</html>
`;
};
